import { Route } from './Route';

interface VenderMenuItem {
  key: string;
  title: string;
  route: Route;
}

export const venderMenuItems: VenderMenuItem[] = [
  {
    key: 'legal',
    title: '特定商取引法に基づく表記',
    route: {
      route: 'legal',
    },
  },
  {
    key: 'privacy',
    title: 'プライバシーポリシー',
    route: {
      route: 'privacy',
    },
  },
  {
    key: 'terms',
    title: 'ご利用規約',
    route: {
      route: 'terms',
    },
  },
  {
    key: 'about',
    title: '＆COCOについて',
    route: {
      route: 'about',
    },
  },
];
